<button mat-raised-button [color]="colorType" (click)="sendGoogleReviewLink()" matTooltip="Request review on Google page by the patient">
  <span fxLayout="row" fxLayoutAlign="center center"
    >Request Review <mat-progress-spinner class="request-review-spinner" *ngIf="loading" [diameter]="16" [mode]="'indeterminate'"></mat-progress-spinner
  ></span>
</button>
